/**
 * @group Action
 * @summary <blockquote>Standard error messages for server action operations.</blockquote>
 */
export const ACTION_ERROR_MESSAGES = {
  FETCH_FAILED: 'Failed to retrieve data',
  CREATE_FAILED: 'Failed to create item',
  UPDATE_FAILED: 'Failed to update item',
  DELETE_FAILED: 'Failed to delete item',
  SAVE_FAILED: 'Failed to save item',
  PERMISSION_DENIED: 'Permission denied',
  INVALID_DATA: 'Invalid data provided',
  NOT_FOUND: 'Item not found',
} as const; 